import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'

export async function save(name, value) {
  const params = new URLSearchParams()
  params.append('name', name)
  params.append('value', value)

  return httpClient.post('config/save', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function saveNoticeEmail(noticeEmailId, email) {
  const params = new URLSearchParams()
  params.append('notice_email_id', Number(noticeEmailId))
  params.append('email', String(email))

  return httpClient.post('config/save_notice_email', params, apiHeader).then(handleSuccess).catch(handleError)
}

export async function deleteNoticeEmail(noticeEmailId) {
  const params = new URLSearchParams()
  params.append('notice_email_id', noticeEmailId)

  return httpClient.post('config/delete_notice_email', params, apiHeader).then(handleSuccess).catch(handleError)
}
